export const LOCAL_STORAGE = {
  TOKEN: "token",
  IS_LOGIN_IN: "isLoggedIn",
};
